export default "__VITE_ASSET__D0St8udx__"